<template>
  <div>

    <Header />
    <ProjectBlock :projects="projectsGoogle" :title="'Built at Google'" style="margin-top:-18px" />
    <ProjectBlock :projects="projectsBattleAxe" :title="'Built at Battle Axe'" />
    <Footer />
    
    <!-- <ProjectBlock :projects="projectsGoogle" :title="'Built at Google'" />
    <ProjectBlock :projects="projectsInDev" :title="'In development'" />
    <ProjectBlock :projects="projectsBattleAxe" :title="'Built after-hours'" /> -->

    


  </div>
</template>

<script>

export default {
    components: {
    },
    data: () => ({
        projectsGoogle: [
            {
                title: 'AEUX', 
                subtitle: 'Sketch/Figma => Ae', 
                icon: '/icons/aeux.svg', 
                body: `A set of panels for After Effects and Sketch 52+ and a converter for Figma to transfer layers into After Effects. Open source and available to the public.
                        <a href="https://medium.com/google-design/aeux-f79e06e01594" target="_blank">Dev process</a>`,
                link: {
                        text: 'Download',
                        url: 'http://aeux.io'
                    },
            },
        //     {
        //         title: 'DotKit', 
        //         subtitle: 'Animate the dots as states', 
        //         icon: '/icons/opa.svg',
        //         body: `Instead of setting hundreds of keyframes to recreate existing elements, easily animate, re-time, rearrange states like a video timeline and the dots will transition automatically.
                
        //                 Dotkit also serves as the most up-to-date repo for dot state animation.`,
        //         route: {
        //                 text: 'Learn more',
        //                 url: '/dotkit'
        //             },
        //     },
            {
                title: 'Inspector Spacetime', 
                subtitle: 'Motion specs for ENG', 
                icon: '/icons/ist.svg',
                body: `Generated curve data and timing relations between motion elements in a format that ENG will greatly appreciate.
                        -Open source and available to the public.
                        <a href="https://medium.com/google-design/bringing-sketch-and-after-effects-closer-together-d83b3e729c93" target="_blank">Writeup</a>`,
                link: {
                        text: 'Download',
                        url: 'https://google.github.io/inspectorspacetime/'
                    },
            },
            {
                title: 'More for Googlers', 
                subtitle: 'Authentication required', 
                icon: '/icons/rightarrow.svg',
                body: `Custom tools for making the worlds information accessible`,
                link: {
                        text: 'Download',
                        url: 'https://google.blastronaut.co'
                    },
            },
        //     {
        //         title: 'Radness',
        //         subtitle: 'Independent corner rounding for paths',
        //         icon: '/icons/radness.svg',
        //         body: `Work with paths in Ae like the corners in Figma with independent rounding and the highest level of control.`,
        //         route: {
        //                 text: 'Learn more',
        //                 url: '/radness'
        //             },
        //     },
        //     {
        //         title: 'Windfish',
        //         subtitle: 'Keys and layers event links',
        //         icon: '/icons/windfish.svg',
        //         body: `Select keyframes or layers and link them to comp markers in any comp within the project. Update the timing of all linked elements with a click.`,
        //         route: {
        //                 text: 'Learn more',
        //                 url: '/windfish'
        //             },
        //     },
        //     {
        //         title: 'Conclave', 
        //         subtitle: 'Assistant voice for motion',
        //         icon: '/icons/mic.svg',
        //         body: `Built to simplify the process of generating Assitant voices for motion flows. Generate audio files from within After Effects and with voices from multiple regions.
        //                 - Now with system mic recording.`,
        //         route: {
        //                 text: 'Learn more',
        //                 url: '/conclave',
        //             },
        //     },
        //     {
        //         title: 'Moonbase Ae',
        //         subtitle: 'Motion assets across Google',
        //         icon: '/icons/moonbase.svg',
        //         body: `Designed to become the source of truth for motion assets. 
        //                 Useful as a private library or to share with teams. 
        //                 A collaboration between Constellation utilizing the robust Moonbase backend`,
        //         route: {
        //                 text: 'Learn more',
        //                 url: '/moonbase',
        //             },
        //     },
        //     {
        //         title: 'Flugridity',
        //         subtitle: 'Dynamic box resizing in Ae',
        //         icon: '/icons/flugridity.svg',
        //         body: `Create vertical/horizontal rules with global margins and constrain boxes to to these rules for system level animation of resizable blocks.`,
        //         route: {
        //                 text: 'Learn more',
        //                 url: '/flugridity'
        //             },
        //     },
        //     {
        //         title: 'Flattop',
        //         subtitle: 'Remove ugly decimal points from keyframes',
        //         icon: '/icons/flattop.svg',
        //         body: `I mean, do you really enjoy setting a keyframe at 100.0489? Round it to a whole number.`,
        //         route: {
        //                 text: 'Learn more',
        //                 url: '/flattop'
        //             },
        //     },
        ],


        projectsInDev: [
            {
                title: 'Spectrum',
                subtitle: 'Reusable motion patterns',
                icon: '/icons/spectrum.svg',
                body: `Reimagining UX motion design for multiple screens. Exploring the concept of a patterns and tokens for animation.`,
                route: {
                        text: 'Learn more',
                        url: '/Spectrum'
                    },
            },
        ],



        projectsBattleAxe: [
            {
                title: 'Overlord',
                subtitle: 'Vector workflow salvation',
                icon: '/icons/overlord.svg',
                body: 'Transfer Illustrator elements directly into After Effects without importing files. Text and gradients supported for the first time ever.',
                link: {
                        text: 'gcard it',
                        url: 'https://www.battleaxe.co/overlord'
                    },
            },
            {
                title: 'Buttcapper',
                subtitle: 'The stroke cap selector Adobe forgot',
                icon: '/icons/buttcapper.svg',
                body: 'Change stroke caps and joins with a click instead of 17 twirl-downs.',
                link: {
                        text: 'Download',
                        url: 'https://www.battleaxe.co/buttcapper'
                    },
            },
            {
                title: 'Timelord',
                subtitle: 'Animating the hard way, but way easier',
                icon: '/icons/timelord.svg',
                body: 'Transfer Photoshop and Animate layers directly into an After Effects comp and simplify frame-based animation.',
                link: {
                        text: 'gcard it',
                        url: 'https://www.battleaxe.co/timelord'
                    },
            },
            {
                title: 'Anubis',
                subtitle: 'MP4 compression simplified',
                icon: '/icons/anubis.svg',
                body: 'H.264 video compression from all Adobe video apps quicker than opening Media Encoder.',
                link: {
                        text: 'gcard it',
                        url: 'https://www.battleaxe.co/anubis'
                    },
            },
            {
                title: 'RubberHose',
                subtitle: 'Animation rigging for everyone',
                icon: '/icons/rubberhose.svg',
                body: 'Build bendy limbs with a click and set up full characters faster than you ever thought would be possible.',
                link: {
                        text: 'gcard it',
                        url: 'https://www.battleaxe.co/rubberhose'
                    },
            },
            {
                title: 'Hylian',
                subtitle: 'It\'s dangerous to go alone',
                icon: '/icons/hylian.svg',
                body: 'Layer duplication with a property link to the past.',
                link: {
                        text: 'Download',
                        url: 'https://www.battleaxe.co/hylian'
                    },
            },
        ],
  }),
};
</script>

<style>

</style>